import React from 'react'

import img1 from "../../../assets/images/home_page_4/service/01.png"
import img2 from "../../../assets/images/home_page_4/service/02.png"
import img3 from "../../../assets/images/home_page_4/service/03.png"
import img4 from "../../../assets/images/home_page_4/service/04.png"
const Services = () => {
  return (
    <>
      <section id="services" className="services-main-block">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-3 col-6">
              <div className="services-block-first text-center">
                <div className="services-img-first">
                  <img
                    src={img1}
                    className="img-fluid"
                    alt=""
                  />
                </div>
                <div className="services-dtls-first">
                  <h5 className="services-heading-first">Online Support 24/7</h5>
                  <p>Support online 24 hours a day</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-6">
              <div className="services-block-first text-center">
                <div className="services-img-first">
                  <img
                    src={img2}
                    className="img-fluid"
                    alt=""
                  />
                </div>
                <div className="services-dtls-first">
                  <h5 className="services-heading-first">Member Discount</h5>
                  <p>Onevery order over $120.00</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-6">
              <div className="services-block-first text-center">
                <div className="services-img-first">
                  <img
                    src={img3}
                    className="img-fluid"
                    alt=""
                  />
                </div>
                <div className="services-dtls-first">
                  <h5 className="services-heading-first">Money Return</h5>
                  <p>Back guarantee under 7 days</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-6">
              <div className="services-block-first text-center">
                <div className="services-img-first">
                  <img
                    src={img4}
                    className="img-fluid"
                    alt=""
                  />
                </div>
                <div className="services-dtls-first">
                  <h5 className="services-heading-first">Fast, Free Shipping</h5>
                  <p>Fast, Free Shipping</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default Services